(function () {
  'use strict';

  function slideSize(track) {
    var card = track.querySelector('.cm-world__card');
    if (!card) return track.clientWidth;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function initSection(section) {
    if (section.dataset.cmWorldReady === 'true') return;

    var grid = section.querySelector('[data-cm-world-carousel]');
    var bar = section.querySelector('.cm-world__scrollbar');
    var thumb = section.querySelector('.cm-world__scrollbar-thumb');
    var prev = section.querySelector('[data-cm-world-prev]');
    var next = section.querySelector('[data-cm-world-next]');
    if (!grid || !bar || !thumb) return;

    section.dataset.cmWorldReady = 'true';

    function update() {
      var scrollW = grid.scrollWidth;
      var clientW = grid.clientWidth;
      var controls = section.querySelector('.cm-world__controls');

      if (scrollW <= clientW) {
        if (controls) controls.hidden = true;
        return;
      }

      if (controls) controls.hidden = false;

      var ratio = clientW / scrollW;
      var thumbW = Math.max(ratio * 100, 15);
      thumb.style.width = thumbW + '%';

      var maxScroll = scrollW - clientW;
      var pct = maxScroll > 0 ? grid.scrollLeft / maxScroll : 0;
      thumb.style.left = pct * (100 - thumbW) + '%';

      if (prev) prev.disabled = grid.scrollLeft <= 1;
      if (next) next.disabled = grid.scrollLeft >= maxScroll - 1;
    }

    function go(direction) {
      grid.scrollBy({ left: direction * slideSize(grid), behavior: 'smooth' });
    }

    function snapToSlide() {
      var size = slideSize(grid);
      if (!size) return;
      var index = Math.round(grid.scrollLeft / size);
      var maxIndex = Math.max(0, grid.querySelectorAll('.cm-world__card').length - 1);
      index = Math.min(Math.max(index, 0), maxIndex);
      grid.scrollTo({ left: index * size, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    grid.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('a, button')) return;
      if (grid.scrollWidth <= grid.clientWidth) return;

      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = grid.scrollLeft;
      grid.classList.add('is-dragging');
      grid.setPointerCapture(event.pointerId);
    });

    grid.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 4) moved = true;
      grid.scrollLeft = startScroll - delta;
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      grid.classList.remove('is-dragging');
      snapToSlide();
    }

    grid.addEventListener('pointerup', endDrag);
    grid.addEventListener('pointercancel', endDrag);

    grid.addEventListener('click', function (event) {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    if (window.cmBindCarouselScrollbar) {
      window.cmBindCarouselScrollbar(grid, bar, thumb);
    }

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(update).observe(grid, { childList: true, subtree: true });
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('.cm-world').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
